import React from 'react';
import BaseIcon from './BaseIcon';

class PieChartSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 60 60"
      >
        <path
          d="M31.000,60.000 C15.009,60.000 2.000,46.991 2.000,31.000 C2.000,30.448 2.448,30.000 3.000,30.000 C3.552,30.000 4.000,30.448 4.000,31.000 C4.000,45.888 16.112,58.000 31.000,58.000 C45.888,58.000 58.000,45.888 58.000,31.000 C58.000,16.112 45.888,4.000 31.000,4.000 C30.448,4.000 30.000,3.552 30.000,3.000 C30.000,2.448 30.448,2.000 31.000,2.000 C46.991,2.000 60.000,15.009 60.000,31.000 C60.000,46.991 46.991,60.000 31.000,60.000 ZM25.976,24.975 C25.976,25.527 25.528,25.975 24.976,25.975 L1.161,25.975 C1.108,25.983 1.055,25.988 1.000,25.988 C0.448,25.988 -0.000,25.553 -0.000,25.001 L-0.000,24.975 L-0.000,24.974 L-0.000,24.974 C0.015,11.217 11.219,0.014 24.975,0.000 C24.975,0.000 24.975,0.000 24.976,0.000 C24.977,0.000 24.982,0.000 24.986,0.000 L25.000,0.000 L25.000,0.000 C25.552,0.000 26.000,0.448 26.000,1.000 C26.000,1.076 25.992,1.149 25.976,1.221 L25.976,24.975 ZM23.976,2.023 C12.114,2.545 2.547,12.112 2.022,23.975 L23.976,23.975 L23.976,2.023 Z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default PieChartSVG;
